import { COMPARE, DATA_UNIT } from '../enum/common.enum';
import _ from 'lodash';

export const processUnit = (value: number, unit: DATA_UNIT = DATA_UNIT.NONE, precision = 1) => {
  if (_.isNil(value)) {
    return null;
  }
  return _.round(value / unit, precision);
};

export const kpiValue = (value: number, unitValue = 1, isDiff = false, precision = 1) => {
  if (_.isNil(value)) {
    return '-';
  }
  // const { unit, precision, mark = '' } = map[kpi] ? map[kpi] : map['default'];
  const num = processUnit(value, unitValue || 1, precision);
  // if (DATA_UNIT.PERCENTAGE === unit) {
  //   return `${mark} ${num.toLocaleString()}%`;
  // }
  if (isDiff && num > 0) {
    return ` +${num.toLocaleString()}`;
  }
  return ` ${num.toLocaleString()}`;
};

export const toCamelCase = (str) => {
  if (!str?.includes('_')) return str;

  // 分割字符串，然后处理
  const result = _.chain(str.split('_'))
    .map((word, index) => (index === 0 ? word.toLowerCase() : _.capitalize(word.toLowerCase())))
    .join('')
    .value();

  return result;
};

export const camelToSnake = (str) => {
  return str.replace(/[A-Z]/g, (letter) => '_' + letter.toLowerCase());
};

export const getDefaultValue = (account, key) => {
  const defaultFiscalYearMap = {
    sbt: 'FY25',
    toshiba: 'FY25',
    toshiba_v2: 'FY25',
  };
  const defaultInfo = {
    fiscalYear: defaultFiscalYearMap[account],
  };
  return defaultInfo[key];
};
